/* eslint-disable no-undef */
/* eslint-disable @typescript-eslint/no-unused-vars */

function getOpdFunctionsConfig() {
  const test = () => {
    return _.join(['a', 'b', 'c'], '->->')
  }

  const value = (values, defaultValue) => {
    if (!values.hospital_name) return defaultValue.value
    return values.hospital_name === 'โรงพยาบาลกงไกรลาศ' ? 10000 : 15000
  }

  const required = (values, defaultValue) => {
    if (!values.hospital_name) return defaultValue.required
    return values.hospital_name === 'โรงพยาบาลกงไกรลาศ'
  }

  const requiredAll = (values, defaultValue) => {
    if (!values.hospital_name) return defaultValue.required
    return values.hospital_name === 'โรงพยาบาลกงไกรลาศ'
  }

  return {
    autoCal: {
      // ...AutoCal,
      test,
      value,
      required,
    },
    validate: {
      requiredAll,
      // ...validate,
    },
  }
}
